exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".masonry-container{margin:0 auto}.masonry-grid{text-align:center;margin:0 auto;align-items:center;margin-bottom:40px}.dialog .container{min-height:0!important}.skill-card{cursor:pointer;display:flex;padding:10px;margin:10px;flex-direction:column}.skill-card__title{padding:0;text-align:center;padding:2px}.skill-card__image{margin-top:10px}.dialog__content{z-index:300!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23a6d8f7","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LazyGrid.vue
// module id = 401
// module chunks = 0